import "../css/header.scss";
import React from "react";
import { Link } from "react-router-dom";

function Header() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      id="shopify-section-header"
      className="shopify-section shopify-section--header"
    >
      <header
        id="section-header"
        className="Header Header--initialized Header--withIcons Header--center"
      >
        <div className="Header__Wrapper js-header-wrapper">
          <div className="Header__FlexItem Header__FlexItem--fill">
            <nav
              className="Header__MainNav Nav hidden-pocket hidden-lap"
              aria-label="Main navigation"
            >
              <ul className="HorizontalList HorizontalList--spacingExtraLoose">
                <li className="HorizontalList__Item ">
                  <Link onClick={toTop} className="Link--primary" to="/shop">
                    Shop
                  </Link>
                </li>
                <li className="HorizontalList__Item">
                  <Link onClick={toTop} className="Link--primary" to="/about">
                    About
                  </Link>
                </li>
                <li className="HorizontalList__Item ">
                  <Link onClick={toTop} className="Link--primary" to="/contact">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="Header__FlexItem Header__FlexItem--logo">
            <h1 className="Header__Logo">
              <Link
                onClick={toTop}
                to="/"
                className="Header__LogoLink"
                style={{
                  fontSize: "28px",
                  textTransform: "uppercase",
                  fontWeight: "800",
                }}
              >
                Bakimball
              </Link>
            </h1>
          </div>
          <div className="Header__FlexItem Header__FlexItem--fill">
            <Link
              onClick={toTop}
              to="/cartpage"
              className="Header__Icon Icon-Wrapper Icon-Wrapper--clickable "
              data-action="open-drawer"
              data-drawer-id="sidebar-cart"
              aria-expanded="false"
              aria-label="Open cart"
            >
              <span className="hidden-phone">
                <svg
                  className="Icon Icon--cart-desktop "
                  role="presentation"
                  viewBox="0 0 19 23"
                >
                  <path
                    d="M0 22.985V5.995L2 6v.03l17-.014v16.968H0zm17-15H2v13h15v-13zm-5-2.882c0-2.04-.493-3.203-2.5-3.203-2 0-2.5 1.164-2.5 3.203v.912H5V4.647C5 1.19 7.274 0 9.5 0 11.517 0 14 1.354 14 4.647v1.368h-2v-.912z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <span className="Header__CartDot" />
            </Link>
          </div>
        </div>
      </header>
      <style
        dangerouslySetInnerHTML={{
          __html:
            ":root {\n      --use-sticky-header: 1;\n      --use-unsticky-header: 0;\n    }\n\n    .shopify-section--header {\n      position: -webkit-sticky;\n      position: sticky;\n    }.Header__LogoImage {\n      max-width: 250px;\n    }\n\n    @media screen and (max-width: 640px) {\n      .Header__LogoImage {\n        max-width: 135px;\n      }\n    }:root {\n      --header-is-not-transparent: 1;\n      --header-is-transparent: 0;\n    }",
        }}
      />
    </div>
  );
}

export default Header;
